import { addItemToCart, deleteItemFromCart } from '../containers/CartPage/CartPage.duck';
import { ADD } from './constants';
import { isArrayLength } from './genericHelpers';
import { createResourceLocatorString } from './routes';
import { showErrorToast } from './toast';

export const extractListingDataForCart = listing => {
  const currentStock = listing && listing.currentStock;
  const quantity = currentStock?.attributes?.quantity;

  const price = listing?.attributes?.price;

  const currency = price?.currency;

  const firstImage = isArrayLength(listing.images) ? listing.images[0] : null;

  const sharetribeImage =
    firstImage &&
    firstImage.attributes &&
    firstImage.attributes.variants &&
    firstImage.attributes.variants['listing-card-2x'] &&
    firstImage.attributes.variants['listing-card-2x'].url;

  const listingId = listing?.id?.uuid;
  const title = listing?.attributes?.title;
  const authorId = listing?.author?.id?.uuid;
  const publicData = listing?.attributes?.publicData;
  const shippingPriceInSubunitsOneItem = publicData?.shippingPriceInSubunitsOneItem;
  const shippingPriceInSubunitsAdditionalItems = publicData?.shippingPriceInSubunitsAdditionalItems;

  return {
    listingId,
    stockCount: 1,
    price,
    title,
    authorId,
    shippingPriceInSubunitsOneItem,
    shippingPriceInSubunitsAdditionalItems,
    currency,
    oldStock: quantity,
    quantity,
    listingImage: sharetribeImage,
  };
};

export const onToggleQuanity = params => {
  const {
    currentItem,
    currentCartItem,
    setCurrentItem,
    setStockDetails,
    stockDetails,
    type,
  } = params;
  const currentItemParams = {
    ...currentItem,
    stockCount: type === ADD ? currentItem?.stockCount + 1 : currentItem?.stockCount - 1,
  };

  stockDetails[currentCartItem.index] = currentItemParams;
  setCurrentItem(currentItemParams);
  setStockDetails(stockDetails);
};

export const removeItemFromCart = async params => {
  const { dispatch, ...rest } = params;
  try {
    const response = await dispatch(deleteItemFromCart(rest));
  } catch (error) {
    showErrorToast('Error removing item from cart');
  }
};

export const getAllCartItems = currentUser => {
  const cartItems = getUserCartDetails(currentUser);

  // Combine cart items from user data and local storage
  const allCartItems = [...(cartItems || [])];

  // Filter out duplicates (assuming cart items have a unique identifier)
  const uniqueCartItems = new Set(allCartItems.map(item => item)); // Or any unique identifier property

  // Convert unique identifiers back to cart items
  const combinedCartItems = Array.from(uniqueCartItems).map(id => {
    // Find the corresponding item in the combined list
    const matchingItem = allCartItems.find(item => item === id);
    return matchingItem;
  });

  // Return the combined and deduplicated cart items
  return combinedCartItems;
};

export const cartItemsCheckoutData = params => {
  try {
  } catch (error) {}
};

export const handleAddToCart = async params => {
  const { isAuthenticated, dispatch, id, cartItems, history, routeConfiguration } = params || {};
  try {
    await dispatch(addItemToCart({ id, cartItems, isAuthenticated, history, routeConfiguration }));
  } catch (error) {
    showErrorToast('Unable to add to cart');
  }
};
export const saveCartAndRedirectToLogin = params => {
  try {
    const { id, history, routeConfiguration } = params || {};
    console.log(params, 'hey params');
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(
        'cart',
        JSON.stringify({
          currentCartId: id,
        })
      );
    }
    history.push(createResourceLocatorString('LoginPage', routeConfiguration, {}, {}));
  } catch (error) {}
};

export const retrieveCartFromSession = () => {
  if (typeof window === 'undefined') return null;

  try {
    const cartData = sessionStorage.getItem('cart');
    if (!cartData) return null;
    const parsedData = JSON.parse(cartData);
    return parsedData.currentCartId;
  } catch (error) {
    return null;
  }
};
export const removeCartFromSession = () => {
  if (typeof window === 'undefined') return false;

  try {
    sessionStorage.removeItem('cart');
    return true;
  } catch (error) {
    return false;
  }
};

// Update cart items with new quantity
export const updateCartWithQuantity = (listingCartDetails, listingId, quantity = 1) => {
  if (!listingCartDetails || !listingId || !quantity) return listingCartDetails || [];
  return listingCartDetails.map(item =>
    item.listingId === listingId?.uuid
      ? { ...item, stockCount: Number.parseInt(quantity, 10) }
      : item
  );
};
